import { useState, useEffect } from "react";
import { useSession } from "next-auth/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
  Flex,
  Progress
} from "@chakra-ui/react";
import { getAccount } from "utils/sessionHelper";
import { Preview } from "components/add-people";
import { ContactListDropdown } from "components/contact-list-dropdown";
import { moveContacts } from "controllers/list";
import { ModalInfoIcon } from "components/popups/ModalInfoIcon";
import { textStyle, variant } from "theme/names";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  currentListId: number;
  contacts: any[];
  onFinish?: () => void;
}

export function MoveListPopup({
  isOpen,
  onClose,
  currentListId,
  contacts = [],
  onFinish = () => {},
}: Props) {
  const { data: session } = useSession() ?? {};
  const contactLists = getAccount(session)?.contactLists;
  const listName = contactLists?.find((l) => l.id === currentListId)?.name;
  const [selectedList, setSelectedList] = useState<any>(
    contactLists?.filter((l) => l.id !== currentListId)?.[0]
  );
  const [isMoving, setIsMoving] = useState<boolean>(false);
  const [loaderData, setLoaderData] = useState<any>({});

  useEffect(() => {
    setSelectedList(contactLists?.filter((l) => l.id !== currentListId)?.[0]);
  }, [currentListId]);

  const handleMove = async () => {
    setIsMoving(true);
    await moveContacts(
      getAccount(session)?.id,
      contacts,
      currentListId,
      selectedList?.id,
      setLoaderData
    );
    setIsMoving(false);
    onClose();
    onFinish();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {/* <ModalInfoIcon /> */}
          Move contacts
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box>
            <Text textStyle={textStyle["body.medium.light"]}>Moving following contacts of {listName}'s list:</Text>
            <Preview
              people={contacts}
              align="start"
              noOfImagePreview={5}
              mainContainerProps={{ pl: 0 }}
            />
          </Box>
          <Flex alignItems="center" mt="4">
            <Text mr={4} textStyle={textStyle["body.medium.light"]} fontWeight="medium">Select list: </Text>
            <ContactListDropdown
              onSelectList={(list) => setSelectedList(list)}
              value={selectedList}
              filterListIds={[currentListId]}
            />
          </Flex>
        </ModalBody>

        <ModalFooter justifyContent="center" flexDir="column">
          {loaderData?.total > 0 && isMoving && (
            <Box w="100%" h="40px" mt="5">
              <Progress
                size="xs"
                rounded="full"
                value={Math.floor((loaderData?.done / loaderData?.total) * 100)}
              />
            </Box>
          )}
          <Flex justifyContent="flex-end" w="100%">
            <Button
              // variant="ghost"
              onClick={onClose}
              mr="2"
              isDisabled={isMoving}
              variant="tertiary"
            >
              Cancel
            </Button>
            <Button
              // colorScheme="twitter"
              // mr={3}
              onClick={handleMove}
              isLoading={isMoving}
              variant={variant.Button.primary}
            >
              Move
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
